import Promise from 'promise';
import { axios } from '../_helpers';

export const CourseSettingService = {
    getCourseList,
    searchCources,
    sortCources,
    createCollection,
    getAllCourseVideos,
    createCollectionBookCode
};

//
function getCourseList() {
    return axios.get('getAllCourses').then((response) => {
        return response.data;
    }).catch((error) => {
        return Promise.reject(error);
    });
};

//
function searchCources(serchTerm) {
    return axios.get('api/lmscourse/searchcourse?serchTerm='+serchTerm).then((response) => {
        return response.data;
    }).catch((error) => {
        return Promise.reject(error);
    });
};

function sortCources(sortBy,col) {
    return axios.get('api/lmscourse/sortcourse?sortBy='+sortBy+'&col='+col).then((response) => {
        return response.data;
    }).catch((error) => {
        return Promise.reject(error);
    });
};

function createCollection(collection) {
    return axios.post('addCollection', collection).then((response) => {
        return response.data;
    }).catch((error) => {
        return Promise.reject(error);
    });
};

function getAllCourseVideos(bookId){
    return new Promise(function (resolve, reject) {
        axios.get('getAllCourseVideos?bookId=' + bookId).then((res) => {
            if (res.isSuccess) {
                resolve(res.data);
            } else {
                reject(res.message);
            }
        }).catch(error => { 
            reject(error.message);
        });
    });
}

function createCollectionBookCode(collection) {
    return new Promise(function (resolve, reject) {
        axios.post('addCollection', collection).then((res) => {
            resolve(res);
        }).catch(error => { 
            reject(error.message);
        });
    });
};



// WEBPACK FOOTER //
// ./src/_services/course-setting.service.js